<template lang="html">

  <form class="row-between" id="formContacto" @submit.prevent="validateBeforeSubmit">

    <div class="contenedor-input middle">
      <input type="text" class="input-text"
      v-validate="'required'"
      name="name" :placeholder="$t('formulario.nombre_apellidos')+'*'"/>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('name') }}</span>
    </div>

    <div class="contenedor-input middle">
      <input type="text" class="input-text"
      v-validate="'required|email'"
      name="email" :placeholder="$t('formulario.email')+'*'"/>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
    </div>

    <div class="contenedor-input middle">
      <input type="text" class="input-text"
      v-validate="'length:9'"
      name="phone" :placeholder="$t('formulario.telefono')"/>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('phone') }}</span>
    </div>

    <div class="contenedor-input middle">
      <input type="text" class="input-text"
      v-validate="'required'"
      name="subject" :placeholder="$t('formulario.asunto')+'*'"/>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('subject') }}</span>
    </div>


    <div class="contenedor-input">
      <textarea :placeholder="$t('formulario.mensaje')+'*'"
      name="message" v-validate="'required'"></textarea>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('message') }}</span>
    </div>

    <div class="contenedor-check">
      <input type="checkbox" id="newsletter" name="newsletter">
      <label for="newsletter">Acepto recibir comunicaciones y novedades del Depto. Prácticas y Empleo de UFV.</label>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('newsletter') }}</span>
  </div>

    <div class="contenedor-check">
      <input type="checkbox" id="politica" v-validate="'required'" name="politica">
      <label for="politica">Acepto y autorizo a que mis datos sean tratados por la Universidad Francisco de Vitoria, para su análisis y segmentación en relación con las preferencias educativas. Puede consultar la información ampliada en la <a href="https://www.ufv.es/politica-de-privacidad-doiu" target="_blank">web</a>.</label>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica') }}</span>
    </div>

    <input type="hidden" name="type" value="contacto">

    <input type="hidden" name="conecta2" value="0">


    <button class="btn -skull" v-if="!!!enviado" :loading="loading">{{$t('formulario.enviar')}}</button>
    <h3 v-if="enviado" class="enviado">Enviado</h3>

  </form>

</template>

<script lang="js">


  import Vue from 'vue';
  import VeeValidate from 'vee-validate';

  Vue.use(VeeValidate);

  import {mapGetters, mapActions} from 'vuex'

  export default  {
    name: 'formulario',
    props: [],
    mounted() {

    },
    data() {
      return {
        clicked : false,
        enviado : false,
        loading : false
      }
    },
    methods: {
      ...mapActions(['sendContacto']),
      validateBeforeSubmit : function(){

        this.clicked = true;
        this.$validator.validateAll().then(canSend => {
          if(canSend){
            this.loading = true;
            this.sendContacto($("#formContacto").serialize())
            .then(result =>{
              if(result){
                $("#formContacto")[0].reset();
                this.enviado = true;
                this.loading = false;
              }
            });
          }
        });
      },
    },
    computed: {

    }
  }
</script>

<style scoped lang="scss">
.contacto {

}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/contacto/formulario.vue